import { render, staticRenderFns } from "./synthesis.vue?vue&type=template&id=065cc576&scoped=true&"
import script from "./synthesis.vue?vue&type=script&lang=js&"
export * from "./synthesis.vue?vue&type=script&lang=js&"
import style0 from "./synthesis.vue?vue&type=style&index=0&id=065cc576&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065cc576",
  null
  
)

export default component.exports